import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
interface EdSwitchProps {
  label?: string;
  onChange: any;
  value: boolean;
  id: string;
  disabled?: boolean;

}

export default function EdSwitch({
  id,
  label,
  value = true,
  onChange,
  disabled = false,

}: EdSwitchProps) {
  return (
    <div className="flex gap-1">
      <FormControlLabel
        disabled={disabled}
        onChange={onChange}
        control={
          <Switch
            color="primary"
            id={id}
            sx={{
             
              "& .MuiSwitch-thumb": {
                backgroundColor: "#ffffff",
              },
              "& .MuiSwitch-track": {
                backgroundColor: "#000000 !important",
                border: 0,
                opacity: 0.5,
              },
              "& .Mui-checked .MuiSwitch-thumb": {
                backgroundColor: "#B80F15",
              },
              "& .Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#B80F15 !important",
                opacity: 1,
              },
            }}
          />
        }
        checked={value}
        label={label}
        labelPlacement="end"
        sx={{
          color: "black"
        }}
      />
      
    </div>
  );
}
